import React from 'react';
import { motion } from 'framer-motion';
import './Timeline.css';

const Timeline = ({ events }) => {
    if (!events || events.length === 0) {
        return null;
    }

    return (
        <div className="timeline-container">
            {events.map((event, index) => (
                <motion.div
                    key={`${event.date}-${index}`}
                    className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}
                    initial={{ opacity: 0, x: index % 2 === 0 ? -100 : 100 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: index * 0.2 }}
                >
                    <div className="timeline-content">
                        <motion.div
                            className="timeline-date"
                            whileHover={{ scale: 1.1 }}
                        >
                            {event.date}
                        </motion.div>
                        <motion.h3
                            className="timeline-title"
                            whileHover={{ scale: 1.05 }}
                        >
                            {event.title}
                        </motion.h3>
                        <motion.h4
                            className="timeline-subtitle"
                            whileHover={{ scale: 1.05 }}
                        >
                            {event.company}
                        </motion.h4>
                        <motion.p
                            className="timeline-description"
                        >
                            {event.description}
                        </motion.p>
                    </div>
                </motion.div>
            ))}
        </div>
    );
};

export default Timeline; 